import Locale from '../interfaces/Locale';

const LOCALE_STORAGE_KEY = 'locale';
export const DEFAULT_LOCALE: Locale = 'en';
const SUPPORTED_LOCALES: Locale[] = ['en', 'es'];

const isSupportedLocale = (value: string | null): value is Locale =>
  SUPPORTED_LOCALES.includes(value as Locale);

const readSavedLocale = () => {
  try {
    return localStorage.getItem(LOCALE_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const saveLocale = (locale: Locale) => {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    return;
  }
};

export const getInitialLocale = (): Locale => {
  const savedLocale = readSavedLocale();
  if (isSupportedLocale(savedLocale)) return savedLocale;

  const urlLocale = new URLSearchParams(window.location.search).get(LOCALE_STORAGE_KEY);
  if (isSupportedLocale(urlLocale)) return urlLocale;

  const browserLanguage = navigator.language.split('-')[0];
  return isSupportedLocale(browserLanguage) ? browserLanguage : DEFAULT_LOCALE;
};
